import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import "./user.css"

const FriendRequests = () => {
    return (
        <div>
            <div className="friend-requests-links">
                <NavLink to="/profile/friend-requests/">
                    <p className="community">Received</p>
                </NavLink>
                <NavLink to="/profile/friend-requests/sent">
                    <p className="community">sent</p>
                </NavLink>
                <NavLink to="/profile/friend-requests/suggested">
                    <p className="community">Suggested</p>
                </NavLink>
            </div>
            <div className="">
                <Outlet />
            </div>
        </div>
    )
}

export default FriendRequests